var ComparisonABTestingJS = (function ($) {

    function hideComparisonWithStickyBar() {
        $("#comparisonProducts").addClass("comparison-ab-testing");
        $(".price-box").addClass("comparison-ab-testing");
        $("#right-container").addClass("comparison-ab-testing");
        $("#stickyBarShowContainerButton").addClass("comparison-ab-testing");

        $("#comparisonProducts").removeClass("comparison-sticky-bar-ab-testing");
        $(".comparing-rims-container").removeClass("comparison-sticky-bar-ab-testing");
    }

    function showComparisonWithStickyBar() {
        $("#comparisonProducts").removeClass("comparison-ab-testing");
        $(".price-box").removeClass("comparison-ab-testing");
        $("#right-container").removeClass("comparison-ab-testing");
        $("#stickyBarShowContainerButton").removeClass("comparison-ab-testing");

        $("#comparisonProducts").addClass("comparison-sticky-bar-ab-testing");
        $(".comparing-rims-container").addClass("comparison-sticky-bar-ab-testing");

        window.THEME.$document.trigger("updateContainerGroupsEqualHeightByMax");
    }

    return {
        hideComparisonWithStickyBar: hideComparisonWithStickyBar,
        showComparisonWithStickyBar: showComparisonWithStickyBar
    }

})($);

$(document).ready(function () {
    ComparisonABTestingJS.hideComparisonWithStickyBar();
});